module.exports = __webpack_public_path__ + "img/form-lower-title-tablet.0ee305fc.png";